<div class="align-items-baseline">
  <label *ngIf="label">
    <jhi-bary-title [title]="label"></jhi-bary-title>
  </label>
  <div class="form-check form-check-inline">
    <input type="radio" class="form-check-input with-gap" [id]="leftId + '-left'" [name]="id" [value]="leftValue" [formControl]="control" checked mdbInput />
    <label class="form-check-label" [for]="leftId + '-left'">
      {{ leftLabel }}
      <i *ngIf="leftTooltip" class="fas fa-circle-info ml-1" [mdbTooltip]="leftTooltip"></i>
    </label>
  </div>
  <div class="form-check form-check-inline" *ngIf="middleLabel && middleValue">
    <input type="radio" class="form-check-input with-gap" [id]="middleId + '-middle'" [name]="id" [value]="middleValue" [formControl]="control" mdbInput />
    <label class="form-check-label" [for]="middleId + '-middle'">
      {{ middleLabel }}
      <i *ngIf="middleTooltip" class="fas fa-circle-info ml-1" [mdbTooltip]="middleTooltip"></i>
    </label>
  </div>
  <div class="form-check form-check-inline">
    <input type="radio" class="form-check-input with-gap" [id]="rightId + '-right'" [name]="id" [value]="rightValue" [formControl]="control" mdbInput />
    <label class="form-check-label" [for]="rightId + '-right'">
      {{ rightLabel }}
      <i *ngIf="rightTooltip" class="fas fa-circle-info ml-1" [mdbTooltip]="rightTooltip"></i>
    </label>
  </div>
</div>
